import { AspectViewType } from '@lib.core/entities/indicator/indicator-view-type';

export interface AspectView {
  views: AspectViewConfigModel[];
}

export class AspectViewConfigModel {
  nameId: string;
  type: AspectViewType;
  visualizations: Visualization[];
  config: any;

  constructor(nameId: string, type: AspectViewType, visualizations: Visualization[], config: any) {
    this.nameId = nameId;
    this.type = type;
    this.visualizations = visualizations;
    this.config = config;
  }
}

export interface Visualization {
  nameId: string;
  type: AspectViewType;
}

const AspectViewTypeOrder: { [key in AspectViewType]: number } = {
  [AspectViewType.CARD]: 1,
  [AspectViewType.KPI]: 2,
  [AspectViewType.MAP]: 3,
  [AspectViewType.CHART]: 4,
  [AspectViewType.RANKING]: 5
};

export function sortAspectViewsByAspectType(views: AspectViewConfigModel[]): AspectViewConfigModel[] {
  return views.sort((a, b) => AspectViewTypeOrder[a.type] - AspectViewTypeOrder[b.type]);
}
